import { useList } from '@refinedev/core';
import { BedDouble, Activity, Utensils, Calendar, Compass, Map } from 'lucide-react';

interface StatCardProps {
  title: string;
  count: number;
  icon: React.ElementType;
  color: string;
}

function StatCard({ title, count, icon: Icon, color }: StatCardProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex items-center gap-4">
        <div className={`p-3 rounded-lg ${color}`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
        <div>
          <p className="text-sm text-gray-500">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{count}</p>
        </div>
      </div>
    </div>
  );
}

export function DashboardPage() {
  const { data: rooms } = useList({ resource: 'rooms' });
  const { data: activities } = useList({ resource: 'activities' });

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <StatCard
          title="Rooms"
          count={rooms?.total ?? 0}
          icon={BedDouble}
          color="bg-blue-500"
        />
        <StatCard
          title="Activities"
          count={activities?.total ?? 0}
          icon={Activity}
          color="bg-green-500"
        />
        <StatCard
          title="Dining Venues"
          count={0}
          icon={Utensils}
          color="bg-orange-500"
        />
        <StatCard
          title="Events"
          count={0}
          icon={Calendar}
          color="bg-purple-500"
        />
        <StatCard
          title="Tours"
          count={0}
          icon={Compass}
          color="bg-teal-500"
        />
        <StatCard
          title="Attractions"
          count={0}
          icon={Map}
          color="bg-pink-500"
        />
      </div>

      <div className="mt-8 bg-white rounded-xl shadow-sm p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <a
            href="/rooms/create"
            className="p-4 text-center bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <BedDouble className="w-8 h-8 mx-auto text-gray-600 mb-2" />
            <span className="text-sm font-medium text-gray-700">Add Room</span>
          </a>
          <a
            href="/activities/create"
            className="p-4 text-center bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Activity className="w-8 h-8 mx-auto text-gray-600 mb-2" />
            <span className="text-sm font-medium text-gray-700">Add Activity</span>
          </a>
          <a
            href="/dining/create"
            className="p-4 text-center bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Utensils className="w-8 h-8 mx-auto text-gray-600 mb-2" />
            <span className="text-sm font-medium text-gray-700">Add Dining</span>
          </a>
          <a
            href="/tours/create"
            className="p-4 text-center bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Compass className="w-8 h-8 mx-auto text-gray-600 mb-2" />
            <span className="text-sm font-medium text-gray-700">Add Tour</span>
          </a>
        </div>
      </div>
    </div>
  );
}
